export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'rujia-lunli-chuantong',
    name: '儒家伦理传统',
    description: '探索韩国儒家伦理的历史渊源、核心思想及其对韩国社会的深远影响，了解忠孝仁义在韩国的当代传承与演变。',
    icon: 'ri-book-open-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Korean%20Confucian%20scholar%20studying%20ancient%20texts%20in%20a%20serene%20hanok%20study%20room%20with%20warm%20wooden%20furniture%20and%20calligraphy%20scrolls%2C%20soft%20natural%20light%20streaming%20through%20paper%20windows%2C%20elegant%20and%20scholarly%20atmosphere%2C%20minimalist%20composition%20with%20rich%20cultural%20details&width=400&height=400&seq=cat-thumb-0&orientation=squarish',
    articleCount: 8,
  },
  {
    slug: 'xiandai-shehui-lunli',
    name: '现代社会伦理观',
    description: '分析韩国在快速现代化进程中伦理观念的转型与调适，探讨个人主义、集体主义与社会责任之间的张力与平衡。',
    icon: 'ri-building-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Seoul%20cityscape%20blending%20traditional%20Korean%20architecture%20with%20contemporary%20skyscrapers%2C%20warm%20golden%20hour%20lighting%2C%20diverse%20people%20walking%20on%20busy%20streets%2C%20harmonious%20coexistence%20of%20tradition%20and%20modernity%2C%20clean%20urban%20aesthetic%20with%20soft%20atmospheric%20tones&width=400&height=400&seq=cat-thumb-1&orientation=squarish',
    articleCount: 6,
  },
  {
    slug: 'jiating-shehui-lunli',
    name: '家庭与社会伦理',
    description: '深入韩国家庭伦理的核心——孝道、家庭责任、代际关系，以及家庭伦理在社会秩序中的基础性作用。',
    icon: 'ri-home-heart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20Korean%20family%20gathering%20in%20a%20cozy%20hanok%20living%20room%2C%20multiple%20generations%20sharing%20a%20traditional%20meal%20together%2C%20soft%20warm%20lighting%20from%20paper%20lanterns%2C%20genuine%20smiles%20and%20respectful%20gestures%2C%20cultural%20warmth%20and%20harmony%2C%20editorial%20lifestyle%20photography&width=400&height=400&seq=cat-thumb-2&orientation=squarish',
    articleCount: 7,
  },
  {
    slug: 'zhichang-lunli-guifan',
    name: '职场伦理规范',
    description: '解读韩国独特的职场文化——上下级关系、团队协作、敬业精神，以及现代韩国企业对传统职场伦理的改革与创新。',
    icon: 'ri-briefcase-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20office%20environment%20with%20colleagues%20respectfully%20collaborating%20in%20a%20modern%20workspace%2C%20clean%20minimalist%20design%20with%20warm%20wooden%20accents%2C%20natural%20light%20through%20large%20windows%2C%20professional%20yet%20harmonious%20atmosphere%2C%20editorial%20corporate%20photography&width=400&height=400&seq=cat-thumb-3&orientation=squarish',
    articleCount: 5,
  },
  {
    slug: 'yingshi-wenhua-lunli',
    name: '影视文化中的伦理',
    description: '通过韩国影视作品透视社会伦理议题——家庭冲突、阶级矛盾、人性考验，解读韩影韩剧背后的伦理密码。',
    icon: 'ri-film-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20film%20scene%20aesthetic%20with%20dramatic%20lighting%20and%20emotional%20depth%2C%20traditional%20and%20modern%20elements%20intertwined%2C%20warm%20cinematic%20color%20grading%20with%20deep%20shadows%2C%20artistic%20composition%20evoking%20Korean%20cinema%20atmosphere%2C%20cultural%20storytelling%20visual&width=400&height=400&seq=cat-thumb-4&orientation=squarish',
    articleCount: 6,
  },
];